<template>
  <div>
    <div class="newBox">
      <div class="doT-one"></div>
      <div class="doT-two"></div>
      <div class="news">
        <p class="news-P-one">{{$t("i.system.news")}}</p>
        <!--<p class="news-P-two">The latest news</p>-->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "LatestNews"
  }
</script>

<style scoped>
  .newBox{
    width: 862px;
    height: 35px;
    margin-top: 30px;
  }
  .doT-one{
    width: 10px;
    height: 10px;
    background-color: #e50020;
    margin-left: 105px;
    float: left;
  }
  .doT-two{
    width: 10px;
    height: 10px;
    background-color: #a8a8a9;
    margin-left: -10px;
    margin-top: 20px;
    float: left;
  }
  .news-P-one{
    float: left;
    display: inline;
    margin-left: 15px;
    font-size: 30px;
    margin-top: -8px;
  }
  /*.news-P-two{*/
    /*float: left;*/
    /*display: inline;*/
    /*font-size: 20px;*/
    /*color: #969696;*/
    /*margin-top: 4px;*/
    /*margin-left: 8px;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/common/components/LatestNews.vue